<template>
  <div class="banner">
    <div class="landing-page__container">
      <div class="banner__wrapper">
        <h2 class="landing-page__title banner__main-title">
          <div>
            {{ $t('landing.mainTitle.firstText') }}
            <span>{{ $t('landing.mainTitle.firstSecond') }}</span>
          </div>
          <div>
            <span>{{ $t('landing.mainTitle.firstThird') }}</span>
            {{ $t('landing.mainTitle.firstFourth') }}
          </div>
        </h2>
        <h1 class="banner__title">
          {{ $t('landing.makingBusiness') }}
        </h1>
        <div class="banner__subtitle">
          {{ $t('landing.knowledgeBase.firstText') }}
          <span>{{ $t('landing.knowledgeBase.secondText') }}</span>
          {{ $t('landing.knowledgeBase.thirdText') }}
        </div>
        <button
          class="landing-page__button banner__button"
          @click="goToPage('selectionService')"
        >
          {{ $t('landing.registerACompany') }}
        </button>
      </div>
      <div class="banner__list">
        <div
          v-for="elem in bannerInfo"
          :key="elem.id"
          class="banner-item"
        >
          <div
            class="banner-item__image"
            :class="`banner-item__image_${elem.size}`"
          >
            <i
              :class="`ub-icon-${elem.image}`"
            >
            </i>
          </div>
          <p
            class="banner-item__text"
            v-html="elem.text"
          >
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Banner',
  computed: {
    bannerInfo() {
      return [
        {
          id: 1,
          text: `
            ${this.$t('landing.bestCountry.firstText')}
            ${this.$t('landing.bestCountry.secondText')}`,
          image: 'banner-svg-1',
          size: 'big',
        },
        {
          id: 2,
          text: `
            ${this.$t('landing.dailyBasis.firstText')}
            ${this.$t('landing.dailyBasis.secondText')}
            ${this.$t('landing.dailyBasis.thirdText')}`,
          image: 'banner-svg-2',
          size: 'middle',
        },
        {
          id: 3,
          text: `
            ${this.$t('landing.getInstructions.firstText')}
            ${this.$t('landing.getInstructions.secondText')}
            ${this.$t('landing.getInstructions.thirdText')}
            ${this.$t('landing.getInstructions.fourthText')}
            ${this.$t('landing.getInstructions.fifthText')}`,
          image: 'banner-svg-3',
          size: 'small',
        },
        {
          id: 4,
          text: `
            ${this.$t('landing.serviceProvided.firstText')}
            ${this.$t('landing.serviceProvided.secondText')}
            ${this.$t('landing.serviceProvided.thirdText')}`,
          image: 'banner-svg-4',
          size: 'bigger',
        },
      ];
    },
  },
  methods: {
    goToPage(route) {
      this.$router.push({
        name: `${route}-${this.$i18n.locale}`,
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../sass/variables";
@import "../../sass/mixins";

  .banner {
    padding-top: 215px;
    padding-bottom: 100px;

    &__main-title {
      text-align: center;
      color: $color-mine-shaft-dark;
      letter-spacing: 1px;
      line-height: 1.3;

      div {
        span {
          color: $color-royal-blue;
          font-family: $font-landing-heavy;
          letter-spacing: 0;
        }
      }
    }

    &__list {
      display: flex;
      justify-content: space-between;
      background: $color-shark;
      border-radius: $borderRadiusMax;
      padding: 55px 45px 45px 77px;
      position: relative;

      &:before {
        content: '';
        position: absolute;
        top: -12px;
        left: 50%;
        transform: translateX(-50%);
        border-left: 22px solid transparent;
        border-right: 22px solid transparent;
        border-bottom: 12px solid $color-shark;
      }
    }

    &-item {
      display: flex;
      flex-direction: column;
      align-items: center;

      &__image {
        position: relative;
        max-height: 59px;

        &_big {
          top: -11px;
          left: -3px;

          i {
            font-size: 60px;
          }
        }

        &_bigger {
          top: -14px;
          left: -13px;

          i {
            font-size: 60px;
          }
        }

        &_middle {
          left: -6px;
          top: -3px;

          i {
            font-size: 50px;
          }
        }

        &_small {
          left: -7px;

          i {
            font-size: 45px;
          }

          & + p {
            margin-top: 5px;
          }
        }

        i {
          color: $color-nevada;
        }
      }

      & + .banner-item {
        margin-left: 50px;
      }

      &__text {
        font: $font-size-h2 $font-landing-global;
        color: $color-white;
        text-align: center;
        letter-spacing: .5px;
        line-height: 1.4;

        span {
          display: block;
        }
      }
    }

    &__title {
      font: $font-size-max $font-landing-heavy;
      color: $color-shark;
      text-transform: lowercase;
      text-align: center;
      line-height: .8;
      margin-bottom: 43px;

      @include tablet-old {
        font-size: $font-size-middle;
      }
    }

    &__subtitle {
      font-size: $font-size-icon-sm;
      color: $color-mine-shaft-dark;
      margin-bottom: 106px;
      text-align: center;
      letter-spacing: .1px;

      span {
        color: $color-dodger-blue-dark;
        display: inline-block;
        margin: 0 3px;
        letter-spacing: .5px;
      }
    }

    &__button {
      margin: auto;
      max-width: 309px;
      width: 100%;
      letter-spacing: .4px;
    }

    &__wrapper {
      margin-bottom: 133px;

      @include only-tablet-landscape {
        margin-bottom: 60px;
      }
    }

    &__btn {

      &:hover {
        color: $color-white;
        background: $color-dodger-blue;
      }
    }
  }

@include desktop-only {
  .banner {
    &-item {
      & + .banner-item {
        margin-left: 30px;
      }
    }
  }
}

@include tablet-landscape {
  .banner {
    &__wrapper {
      align-items: center;
    }

    &__list {
      flex-wrap: wrap;
      margin: 0 -15px;
    }

    &-item {
      margin: 15px;
      max-width: 420px;
      min-width: 420px;

      &__image {
        left: 0 !important;
      }

      & + .banner-item {
        margin-left: 15px;
      }
    }
  }
}

@include tablet-old {
  .banner {
    &__list {
      padding: 30px 15px;
    }
  }
}

@include tablet-portrait {
  .banner {
    padding-top: 200px;
    padding-bottom: 70px;

    &__list {
      padding: 15px;
    }

    &-item {
      width: 40%;
      max-width: none;
      min-width: auto;
    }

    &__title {
      font-size: $font-size-landing-h1-tablet;
      text-align: center;
    }

    &__subtitle {
      text-align: center;
    }

    &__wrapper {
      flex-direction: column;
      margin-bottom: 70px;
    }
  }
}

@include mobile {
  .banner {
    padding-top: 178px;
    padding-bottom: 90px;

    &__list {
      &:before {
        top: -11px;
      }
    }

    &-item {
      margin: 0 0 21px 0;
      width: 45%;

      & + .banner-item {
        margin-left: 0;
      }

      &__text {
        font-size: $font-size-base;
        margin-top: 1px;
      }
    }

    &__title {
      font-size: $font-size-landing-lg;
    }

    &__subtitle {
      font-size: $font-size-base;
      margin-bottom: 20px;
    }

    &__wrapper {
      margin-bottom: 83px;
    }

    &__list {
      margin: 0;
    }
  }
}

@include mobile-middle {
  .banner {
    &-item {
      width: 100%;
      max-width: 100%;
    }

    &__list {
      flex-direction: column;
    }
  }
}
</style>
